import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e45295e")

_pushScopeId("data-v-1e45295e")
const _hoisted_1 = {
  key: 0,
  class: "card__title"
}
const _hoisted_2 = { class: "card__content" }
const _hoisted_3 = { class: "sponsor__descr--text" }
const _hoisted_4 = {
  key: 0,
  class: "sponsor__phone--text"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("b", null, "Téléphone: ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("a", {
    class: ["sponsor__card", {
            'disabled': _ctx.notReady
        }],
    href: _ctx.sponsor.websiteUrl,
    style: {cursor: _ctx.sponsor.websiteUrl !== ''? 'pointer': 'default'},
    onClick: _cache[4] || (_cache[4] = (ev) => _ctx.hrefClick(ev, _ctx.sponsor.websiteUrl))
  }, [
    (_ctx.showTitle)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.sponsor.name), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        class: "sponsor__img",
        style: _ctx.sponsorCardStyle,
        src: _ctx.logo
      }, null, 12, ["src"]),
      (_ctx.showDescr)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "sponsor__descr scrollbar--invisible",
            onClickCapture: _cache[1] || (_cache[1] = (ev) => _ctx.focusCard(ev)),
            ref: "descr_text"
          }, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sponsor.description), 1),
            (_ctx.hasPhoneNumber)
              ? (_openBlock(), _createBlock("span", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.sponsor.telephone), 1)
                ]))
              : _createCommentVNode("", true)
          ], 544))
        : _createCommentVNode("", true)
    ]),
    (_ctx.canEdit)
      ? (_openBlock(), _createBlock("i", {
          key: 1,
          class: "card__edit icon-sketch",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editSponsor && _ctx.editSponsor(...args)), ["stop","prevent"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.canEdit)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "card__remove",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createVNode(_component_ConfirmAction, {
            type: "delete",
            onConfirm: _ctx.removeSponsor
          }, null, 8, ["onConfirm"])
        ]))
      : _createCommentVNode("", true)
  ], 14, ["href"]))
})